var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ fontFamily: _vm.clientFont }),attrs:{"id":"app"}},[_c('topo'),_vm._v(" "),_c('b-container',{attrs:{"id":"corpo-site"}},[_c('router-view')],1),_vm._v(" "),_c('rodape')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b7daade","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = Jpem
// module chunks = 1